import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import * as auth from '../actions/auth';
import useForm from '../hooks/useForm';

const initialFieldValues = {
  email: '',
  password: '',
};

const LoginPage = ({ loginUser, errors }) => {
  const { values, handleInputChange } = useForm(initialFieldValues);

  const handleSubmit = (e) => {
    e.preventDefault();
    loginUser(values);
  };

  return (
    <div className="hero is-fullheight has-background-white-bis has-padding-top-20 has-padding-bottom-20 has-padding-50-tablet">
      <div className="container is-fluid">
        <div className="columns is-centered">
          <div className="column is-6-tablet is-4-desktop">
            <h1 className="title">Login</h1>

            <div className="box">
              {(!!errors.emailnotfound ||
                !!errors.email ||
                !!errors.password ||
                !!errors.passwordincorrect) && (
                <div className="notification is-danger is-light">
                  Invalid credentials
                </div>
              )}

              <form noValidate onSubmit={handleSubmit}>
                <div className="field">
                  <label className="label" htmlFor="email">
                    Email
                  </label>
                  <div className="control">
                    <input
                      className="input"
                      onChange={handleInputChange}
                      value={values.email}
                      id="email"
                      type="email"
                      name="email"
                    />
                  </div>
                </div>

                <div className="field">
                  <label className="label" htmlFor="password">
                    Password
                  </label>
                  <div className="control">
                    <input
                      className="input"
                      onChange={handleInputChange}
                      value={values.password}
                      id="password"
                      type="password"
                      name="password"
                    />
                  </div>
                </div>

                <div className="has-margin-top-30">
                  <button
                    type="submit"
                    className="button is-fullwidth is-primary"
                  >
                    Login
                  </button>
                </div>

                <hr />

                <Link
                  to="/register"
                  className="button is-fullwidth is-primary is-outlined"
                >
                  Register
                </Link>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  errors: state.auth.errors,
});

const mapActionToProps = {
  loginUser: auth.loginUser,
};

export default connect(mapStateToProps, mapActionToProps)(LoginPage);
